import React from 'react';
import { useNavigate } from 'react-router-dom';

const RecentInvoices = ({ recentInvoices }) => {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '4px', boxShadow: '0 1px 2px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
      <div style={{ padding: '0.5rem 0.75rem', borderBottom: '1px solid var(--border)', fontWeight: '600', fontSize: '12px', backgroundColor: 'var(--bg)' }}>
        🕐 Ostatnie faktury
      </div>
      <div style={{ padding: '0.5rem' }}>
        {recentInvoices?.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
            {recentInvoices.slice(0, 5).map((inv, idx) => (
              <div key={idx} style={{
                padding: '0.4rem 0.6rem', backgroundColor: idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)',
                borderRadius: '3px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                cursor: 'pointer', fontSize: '10px'
              }} onClick={() => navigate(`/purchase-invoices/${inv.id}`)}>
                <div>
                  <div style={{ fontWeight: '600' }}>{inv.numer_faktury}</div>
                  <div style={{ color: 'var(--text-muted)' }}>{inv.dostawca}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: '600' }}>{parseFloat(inv.wartosc_brutto || 0).toFixed(2)} zł</div>
                  <div style={{ color: 'var(--text-muted)' }}>{inv.data_faktury}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
            Brak faktur
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentInvoices;
